import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import CircularProgress from '@mui/material/CircularProgress'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import ErrorIcon from '@mui/icons-material/Error'
import HeartbeatLoader from './HeartbeatLoader'

export type KeycloakLoadingProps = {
  /**
   * timeout in seconds
   */
  timeoutAfter?: number
}

export function KeycloakLoading(props: KeycloakLoadingProps) {
  const { timeoutAfter } = props
  const { t } = useTranslation()
  const [isTimeout, setIsTimeout] = useState<boolean>(false)

  useEffect(() => {
    if (typeof timeoutAfter === 'undefined') return

    const timer = setTimeout(() => {
      setIsTimeout(true)
    }, timeoutAfter * 1000)

    return () => {
      clearTimeout(timer)
    }
  }, [timeoutAfter])

  return (
    <Stack alignItems="center" justifyContent="center" sx={{ height: '100vh' }}>
      {!isTimeout ? (
        <HeartbeatLoader sx={{ transform: 'scale(4)' }} />
      ) : (
        <>
          <ErrorIcon color="error" fontSize="large" />
          <Typography component="p">{t('component.ui.keycloakLoading.timeoutError.message')}</Typography>
        </>
      )}
    </Stack>
  )
}

export default KeycloakLoading
